/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import e from"react";const t=t=>{const[a,n]=e.useState(0),r=t?.length;return{imageIndex:a,setImageIndex:n,nextImage:()=>{n(a+1>=r?0:a+1)},prevImage:()=>{n(0===a?r-1:a-1)}}};export{t as default};
//# sourceMappingURL=useImageControls.js.map
